import { api } from '../api'

import type { Cart, CartPayload } from './production-carts.types'

export const cartService = {
  get: async (params: { flow_id?: string | null } = {}) => {
    const { data } = await api.get<Cart[]>('/production-carts/', { params })
    return data
  },
  add: async (payload: CartPayload) => {
    const { data: data } = await api.post<Cart>('/production-carts/', payload)
    return data
  },
  update: async (id: number, payload: Partial<CartPayload>) => {
    const { data: data } = await api.patch<Cart>(`/production-carts/${id}/`, payload)
    return data
  },
  delete: async (id: number) => {
    const { data: data } = await api.delete<Cart>(`/production-carts/${id}/`)
    return data
  }
}
